/* PRIETT — quick-add.
   · Desktop  → frosted size panel on the card (hover) adds on size tap.
   · Mobile   → "+" pill opens a bottom sheet (size + color, large touch targets,
                explicit "Agregar" CTA). Touch-first; no hover dependency. */
(function () {
  if (window.__priettQuickAddInit) return;
  window.__priettQuickAddInit = true;

  /* ── Mobile/touch: swipe through a product card's images without opening it ── */
  (function () {
    var cs = null;
    function setSlide(g, n) {
      var imgs = [].slice.call(g.querySelectorAll('.pe-card-img'));
      if (imgs.length < 2) return false;
      n = (n % imgs.length + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('on', k === n); });
      var dots = g.parentElement.querySelector('.pe-card-dots');
      if (dots) [].slice.call(dots.children).forEach(function (d, k) { d.classList.toggle('on', k === n); });
      return true;
    }
    function curIdx(g) {
      var imgs = [].slice.call(g.querySelectorAll('.pe-card-img'));
      var i = imgs.findIndex(function (im) { return im.classList.contains('on'); });
      return i < 0 ? 0 : i;
    }
    document.addEventListener('touchstart', function (e) {
      var g = e.target.closest('[data-card-gallery]');
      if (!g) { cs = null; return; }
      cs = { g: g, x: e.touches[0].clientX, y: e.touches[0].clientY };
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!cs) return;
      var g = cs.g, dx = e.changedTouches[0].clientX - cs.x, dy = e.changedTouches[0].clientY - cs.y;
      cs = null;
      if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy)) return; // not horizontal → let tap/scroll happen
      if (setSlide(g, curIdx(g) + (dx < 0 ? 1 : -1))) {
        g.dataset.swiped = '1';
        setTimeout(function () { delete g.dataset.swiped; }, 450);
      }
    }, { passive: true });
    // a swipe must not also navigate the card link
    document.addEventListener('click', function (e) {
      var card = e.target.closest('.pe-product-card');
      if (!card) return;
      var g = card.querySelector('[data-card-gallery]');
      if (g && g.dataset.swiped) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  })();

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function afterAdd() {
    if (window.__priettHeader && window.__priettHeader.openCart) window.__priettHeader.openCart();
    else document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  /* ───────────────── DESKTOP: hover panel size buttons ───────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pe-quick-add-panel .pe-size-btn[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.dataset.busy === '1') return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var panel = btn.closest('[data-quickadd]');
    var label = panel && panel.querySelector('[data-qa-label]');
    var prevLabel = label ? label.textContent : '';
    btn.dataset.busy = '1';
    if (label) label.textContent = 'Añadiendo…';
    if (window.PriettUX) { window.PriettUX.start(); window.PriettUX.btnLoading(btn, true); }

    addToCart(id, 1).then(function (res) {
      if (res && res.status) { throw new Error(res.description || 'error'); }
      if (window.PriettUX) { window.PriettUX.done(); window.PriettUX.btnDone(btn); }
      if (label) label.textContent = 'Añadido · talla ' + (btn.getAttribute('data-qa-size') || '');
      afterAdd();
      setTimeout(function () { if (label) label.textContent = prevLabel || 'Agregar rápido'; btn.dataset.busy = '0'; }, 1500);
    }).catch(function () {
      if (window.PriettUX) { window.PriettUX.done(); window.PriettUX.btnLoading(btn, false); }
      if (label) label.textContent = 'No disponible';
      setTimeout(function () { if (label) label.textContent = prevLabel || 'Agregar rápido'; btn.dataset.busy = '0'; }, 1500);
    });
  });

  /* ───────────────── MOBILE: bottom sheet ───────────────── */
  var sheet, backdrop, st = null, hideTimer;

  function build() {
    if (sheet) return;
    backdrop = document.createElement('div');
    backdrop.className = 'pe-qs-backdrop';
    sheet = document.createElement('div');
    sheet.className = 'pe-quick-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Agregar al carrito');
    document.body.appendChild(backdrop);
    document.body.appendChild(sheet);

    backdrop.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('on')) closeSheet(); });

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-qs-close]')) { closeSheet(); return; }
      var sw = e.target.closest('[data-qs-color]');
      if (sw) { switchColor(sw.getAttribute('data-qs-handle')); return; }
      var sz = e.target.closest('[data-qs-size]:not([disabled])');
      if (sz) { st.size = sz.getAttribute('data-qs-size'); render(); return; }
      var add = e.target.closest('[data-qs-add]:not([disabled])');
      if (add) { commit(add); return; }
    });
  }

  function fmt(cents) { return '$' + (Number(cents) / 100).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

  function variantForSize(size) {
    if (!st || !st.data) return null;
    var si = st.data.sizeIdx;
    return (st.data.variants || []).filter(function (v) { return v.o[si] === size; })[0] || null;
  }
  function sizeAvailable(size) { var v = variantForSize(size); return !!(v && v.a); }

  function curColor() {
    var c = '';
    (st.group || []).forEach(function (g) { if (g.h === st.curHandle) c = g.c; });
    return c;
  }

  function render() {
    if (!st) return;
    if (sheet) sheet.classList.toggle('pe-qs--loading', !!st.loading);
    var d = st.data, group = st.group || [], hasColor = group.length > 1, cc = curColor();
    var priceHTML = d.compare ? '<span class="was">' + d.compare + '</span>' + d.price : d.price;
    var colorsHTML = hasColor ? (
      '<div class="pe-qs-block"><div class="pe-qs-label">color · <span style="text-transform:none;letter-spacing:0;font-weight:400">' + esc(cc) + '</span></div>' +
      '<div class="pe-qs-swatches">' + group.map(function (g) {
        return '<button type="button" class="pe-qs-sw' + (g.h === st.curHandle ? ' on' : '') + '" data-qs-color="' + esc(g.c) + '" data-qs-handle="' + esc(g.h) + '" title="' + esc(g.c) + '" style="background:' + g.hex + '"></button>';
      }).join('') + '</div></div>'
    ) : '';
    var sizesHTML = '<div class="pe-qs-block"><div class="pe-qs-label"><span>' + (d.sizeName || 'talla').toLowerCase() + '</span><a class="pe-qs-guide" href="' + d.url + '">guía de tallas</a></div>' +
      '<div class="pe-qs-size-grid">' + (d.sizes || []).map(function (s) {
        var av = sizeAvailable(s);
        return '<button type="button" class="pe-qs-size' + (s === st.size ? ' on' : '') + '" data-qs-size="' + esc(s) + '"' + (av ? '' : ' disabled') + '>' + esc(s) + '</button>';
      }).join('') + '</div></div>';
    var v = st.size ? variantForSize(st.size) : null;
    var canAdd = v && v.a;
    var addLabel = st.size ? ('agregar al carrito · ' + d.price) : 'elige tu talla';

    sheet.innerHTML =
      '<button class="pe-qs-handle" data-qs-close aria-label="Cerrar"></button>' +
      '<div class="pe-qs-head">' +
        '<span class="pe-qs-thumb">' + (d.img ? '<img src="' + d.img + '" alt="">' : '') + '</span>' +
        '<span class="pe-qs-meta">' +
          '<span class="pe-qs-name">' + esc(d.title) + '</span>' +
          (hasColor ? '<span class="pe-qs-color">' + esc(cc) + '</span>' : '') +
          '<span class="pe-qs-price">' + priceHTML + '</span>' +
        '</span>' +
        '<button class="pe-qs-x" data-qs-close aria-label="Cerrar"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
      '</div>' +
      colorsHTML + sizesHTML +
      '<button type="button" class="pe-btn solid full lg pe-qs-add" data-qs-add' + (canAdd ? '' : ' disabled') + '>' + addLabel + '</button>' +
      '<a class="pe-qs-view" href="' + d.url + '">ver producto completo</a>';
  }

  function commit(addBtn) {
    var v = st.size ? variantForSize(st.size) : null;
    if (!v || !v.a) return;
    if (window.PriettUX) { window.PriettUX.start(); window.PriettUX.btnLoading(addBtn, true); }
    addToCart(v.id, 1).then(function (res) {
      if (res && res.status) throw new Error('err');
      if (window.PriettUX) { window.PriettUX.done(); }
      closeSheet();
      afterAdd();
    }).catch(function () {
      if (window.PriettUX) { window.PriettUX.done(); window.PriettUX.btnLoading(addBtn, false); }
      addBtn.textContent = 'no disponible';
    });
  }

  // build the sheet's data shape from a /products/{handle}.js response
  var pjCache = {};
  function buildFromJs(p, group, sizeName) {
    var sizeIdx = 0;
    if (p.options && p.options.length) {
      var si = -1;
      p.options.forEach(function (o, k) { if (si < 0 && /talla|size/i.test(o)) si = k; });
      sizeIdx = si < 0 ? p.options.length - 1 : si;
    }
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var sizes = [];
    (p.variants || []).forEach(function (v) { var s = v.options[sizeIdx]; if (sizes.indexOf(s) < 0) sizes.push(s); });
    var compare = (p.compare_at_price && p.compare_at_price > p.price) ? fmt(p.compare_at_price) : null;
    return {
      title: p.title, url: '/products/' + p.handle, img: img, price: fmt(p.price), compare: compare,
      sizeName: sizeName || 'talla', sizeIdx: sizeIdx, sizes: sizes,
      variants: (p.variants || []).map(function (v) { return { id: v.id, o: v.options, a: v.available }; })
    };
  }

  // switch the sheet to a sibling color-product without leaving the page
  function switchColor(handle) {
    if (!st || !handle || handle === st.curHandle) return;
    var group = st.group, sizeName = st.data.sizeName;
    st.curHandle = handle; st.size = null;
    if (pjCache[handle]) { st.data = pjCache[handle]; st.loading = false; render(); return; }
    st.loading = true; render();
    if (window.PriettUX) window.PriettUX.start();
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var d = buildFromJs(p, group, sizeName); pjCache[handle] = d; st.data = d; st.loading = false;
        if (window.PriettUX) window.PriettUX.done(); render();
      })
      .catch(function () { st.loading = false; if (window.PriettUX) window.PriettUX.done(); window.location.href = '/products/' + handle; });
  }

  function openSheet(data) {
    build();
    clearTimeout(hideTimer);
    var sizeIdx = (data.sizeName && data.options) ? data.options.indexOf(data.sizeName) : ((data.options || []).length - 1);
    if (sizeIdx < 0) sizeIdx = 0;
    var initData = {
      title: data.title, url: data.url, img: data.img, price: data.price, compare: data.compare,
      sizeName: data.sizeName, sizeIdx: sizeIdx, sizes: data.sizes || [], variants: data.variants || []
    };
    var handle = data.thisHandle || (data.url || '').split('/').pop();
    st = { data: initData, group: data.group || [], curHandle: handle, size: null, loading: false };
    pjCache = {}; pjCache[handle] = initData;
    render();
    backdrop.style.display = 'block'; sheet.style.display = 'block';
    document.body.classList.add('pe-qs-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { backdrop.classList.add('on'); sheet.classList.add('on'); }); });
  }

  function closeSheet() {
    if (!sheet || !sheet.classList.contains('on')) return;
    sheet.classList.add('closing'); backdrop.classList.add('closing');
    sheet.classList.remove('on'); backdrop.classList.remove('on');
    document.body.classList.remove('pe-qs-lock');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    hideTimer = setTimeout(function () {
      sheet.classList.remove('closing'); backdrop.classList.remove('closing');
      sheet.style.display = 'none'; backdrop.style.display = 'none';
    }, reduce ? 0 : 380);
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }

  // pill / shop-the-look tap → open the sheet for that product
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-qa-toggle]');
    if (!pill) return;
    e.preventDefault();
    e.stopPropagation();
    var host = pill.closest('[data-qa-host]') || pill.closest('.pe-product-card');
    var jsonEl = host && host.querySelector('[data-qa-json]');
    var fallbackUrl = (host && host.getAttribute('data-qa-url')) || pill.getAttribute('data-qa-url');
    if (!jsonEl) { if (fallbackUrl) window.location.href = fallbackUrl; return; }
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (_) { if (fallbackUrl) window.location.href = fallbackUrl; return; }
    if (!data.sizes || !data.sizes.length) { window.location.href = data.url; return; }
    openSheet(data);
  });

  // ── product-card color swatches → swap the card to the sibling product IN PLACE ──
  var cardCache = {};
  function imgU(x) { return x ? (typeof x === 'string' ? x : (x.src || x.url || null)) : null; }
  function sizeUrl(u, w) { if (!u) return u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function rebuildCardQA(card, p, color) {
    var sizes = [], seen = {};
    var variants = (p.variants || []).map(function (v) {
      var sz = v.option1; if (sz && !seen[sz]) { seen[sz] = 1; sizes.push(sz); }
      return { id: v.id, o: v.options || [v.option1], a: v.available, img: v.featured_image ? sizeUrl(imgU(v.featured_image), 300) : null };
    });
    var jsonEl = card.querySelector('[data-qa-json]');
    var prev = {}; if (jsonEl) { try { prev = JSON.parse(jsonEl.textContent); } catch (_) {} }
    if (jsonEl) {
      jsonEl.textContent = JSON.stringify({
        title: p.title, url: '/products/' + p.handle,
        img: p.featured_image ? sizeUrl(imgU(p.featured_image), 300) : null,
        price: fmt(p.price), compare: (p.compare_at_price > p.price) ? fmt(p.compare_at_price) : null,
        options: prev.options || ['Talla'], colorName: prev.colorName || '',
        thisColor: color || '', thisHandle: p.handle, group: prev.group || [],
        sizeName: prev.sizeName || 'Talla', sizes: sizes, colors: prev.colors || [], variants: variants
      });
    }
    // desktop hover-panel size buttons → point to the sibling's variant ids
    card.querySelectorAll('[data-quickadd] [data-qa-size]').forEach(function (btn) {
      var sz = btn.getAttribute('data-qa-size');
      var match = variants.filter(function (v) { return v.o[0] === sz || v.o.indexOf(sz) > -1; });
      var pick = match.filter(function (v) { return v.a; })[0] || match[0];
      if (pick && pick.a) { btn.setAttribute('data-variant-id', pick.id); btn.classList.remove('pe-size-btn--sold'); btn.disabled = false; btn.removeAttribute('aria-disabled'); }
      else { btn.removeAttribute('data-variant-id'); btn.classList.add('pe-size-btn--sold'); btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); }
    });
  }

  function applyCard(card, p, color) {
    var imgs = ((p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : [])).slice(0, 4).map(imgU);
    var gallery = card.querySelector('[data-card-gallery]');
    if (gallery && imgs.length) {
      gallery.innerHTML = imgs.map(function (src, i) { return '<img class="pe-card-img' + (i === 0 ? ' on' : '') + '" src="' + sizeUrl(src, 700) + '" alt="" loading="lazy">'; }).join('');
      var dots = card.querySelector('[data-card-dots]');
      if (dots) { dots.innerHTML = imgs.map(function (_, i) { return '<i' + (i === 0 ? ' class="on"' : '') + '></i>'; }).join(''); dots.style.display = imgs.length > 1 ? '' : 'none'; }
    }
    var onSale = p.compare_at_price && p.compare_at_price > p.price;
    var pEl = card.querySelector('[data-card-price]');
    if (pEl) pEl.innerHTML = onSale ? '<span class="was">' + fmt(p.compare_at_price) + '</span><span class="now">' + fmt(p.price) + '</span>' : '<span>' + fmt(p.price) + '</span>';
    var tag = card.querySelector('[data-card-tag]');
    if (tag) {
      if (onSale) { tag.className = 'pe-product-tag discount'; tag.textContent = '-' + Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) + '%'; tag.hidden = false; tag.style.display = ''; }
      else { tag.hidden = true; tag.style.display = 'none'; }
    }
    var wish = card.querySelector('[data-wish-handle]');
    if (wish) { wish.setAttribute('data-wish-handle', p.handle); wish.classList.remove('active', 'is-saved'); wish.setAttribute('aria-pressed', 'false'); }
    if (window.__priettWish && window.__priettWish.paint) window.__priettWish.paint();
    rebuildCardQA(card, p, color);
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-card-swatch]');
    if (!sw) return;
    e.preventDefault(); e.stopPropagation();
    var card = sw.closest('[data-card-root]') || sw.closest('.pe-product-card');
    if (!card) return;
    var handle = sw.getAttribute('data-sib-handle'), color = sw.getAttribute('data-sib-color');
    if (!handle) return;
    card.querySelectorAll('[data-card-swatch]').forEach(function (s) { s.classList.remove('active'); });
    sw.classList.add('active');
    // instant feedback: link + color label
    if (card.tagName === 'A') card.setAttribute('href', sw.getAttribute('data-sib-url') || ('/products/' + handle));
    var cEl = card.querySelector('[data-card-color]'); if (cEl) { cEl.textContent = color || ''; cEl.hidden = false; cEl.style.display = ''; }
    card.classList.add('pe-card-switching');
    var done = function () { card.classList.remove('pe-card-switching'); };
    if (cardCache[handle]) { applyCard(card, cardCache[handle], color); done(); return; }
    fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) { cardCache[handle] = p; applyCard(card, p, color); done(); })
      .catch(done);
  });
})();
